const campaignTypeEnum = Object.freeze({
  TYPE_NOTIFICATION: 1,
  TYPE_INAPP: 2,
  TYPE_WORKFLOW: 3
})

const campaignTypeLabels = Object.freeze({
  1: 'Campaign_Dialog_Type_SingleStage',
  2: 'Campaign_Dialog_Type_InApp',
  3: 'Campaign_Dialog_Type_MultiStage'
})

export { campaignTypeEnum, campaignTypeLabels }



// WEBPACK FOOTER //
// ./src/modules/campaigns/enum/CampaignTypeEnum.js